import { useMemo } from 'react';
import { PiMagnifyingGlassDuotone } from 'react-icons/pi';

import Node, { Button, NodeValue, NodeValueList } from 'app/admin/optimizationPipelineV2/component/pipeline/nodes/base/Node';

import { useOptimizationPipeline } from 'app/admin/optimizationPipelineV2/component/pipeline/providers/OptimizationPipelineProvider';

function getOutlierResultMeta(outlier) {
    if (outlier === true) { return { value: 'Outlier', severity: 'error' }; }
    if (outlier === false) { return { value: 'Normal', severity: 'success' }; }
    return { value: 'Missing', severity: 'warning' };
}

export default function DataValidationNode(props) {
    const { optimizationPipelineDetail, optimizationPipelineDetailsLoading, optimizationPipelineDetailsLoaded, openPopup } = useOptimizationPipeline();

    const outlier = optimizationPipelineDetail?.cleansed_data?.meta?.outlier_detection?.outlier;
    const outlierDetails = optimizationPipelineDetail?.cleansed_data?.meta?.outlier_detection?.details;

    const outlierMeta = getOutlierResultMeta(outlier);

    const detailRows = useMemo(() => {
        if (!Array.isArray(outlierDetails) || !outlierDetails.length) return [];

        return outlierDetails.map((item, index) => {
            const meta = getOutlierResultMeta(item?.prediction);

            return {
                label: item?.outlier_detector_name || 'Detector ' + (index + 1),
                value: meta.value,
                severity: meta.severity
            };
        });
    }, [outlierDetails]);

    return (
        <Node ref={props.anchorRef} title='Data Validation' icon={PiMagnifyingGlassDuotone} fit={props.fit} loading={optimizationPipelineDetailsLoading || !optimizationPipelineDetailsLoaded}>

            <div className='w-full flex flex-col gap-8'>

                <NodeValue label='Outlier Result' value={outlierMeta.value} severity={outlierMeta.severity} />

                <NodeValueList rows={detailRows} emptyLabel='No Validation Details' />

                <div className='w-full flex flex-col gap-10'>

                    <div className='w-full flex gap-10'>
                        <Button genericType='HISTORY' onClick={() => { openPopup({ type: 'DATA_VALIDATION_HISTORY' }); }} />
                    </div>

                </div>

            </div>

        </Node>
    );
}